/*eslint-disable */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'

// components
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import UserInfoField from './components/userInfoField'
import UserGroupsField from './components/userGroupsField'
import LoadingSpinner from '../../components/loadingSpinner'

// actions
import { fetchUser } from '../../store/actions/userProfile'

// helpers
import { getSortedGroupsWithColor } from './userProfile.helpers'
import { getUserId, isSuperAdmin } from '../../helpers/user'
import { removeEmptyProperties } from '../../helpers/general'

// selectors
import {
  getUserCallError,
  getUserCallStatus,
  getUserObject,
} from '../../store/selectors/userProfile'

import { useIsMobileView } from '../../utils/isMobileView'
import { useTranslation } from 'react-i18next'

import {
  titleContainerStyle,
  editButtonStyle,
  infoContainerStyle,
  infoContainerStyleMobile,
  infoTextStyle,
  infoTitleStyle,
  infoTextStyleMobile,
  superAdminCapsule,
  userProfileDivStyle,
  userProfileDivStyleMobile,
  infoTextStyleEmailMobile,
  infoTextEmailStyle,
} from './userProfileStyles'

function UserProfile() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isMobileView = useIsMobileView()
  const userData = useSelector(getUserObject)
  const dataLoaded = useSelector(getUserCallStatus)
  const dataErrorMessage = useSelector(getUserCallError)
  const [groups, setGroups] = useState([])
  const accessRole = isSuperAdmin()
  const { t } = useTranslation()

  const getUser = async (id) => {
    try {
      if (Object.keys(removeEmptyProperties(userData))?.length > 0) return
      await dispatch(fetchUser(id)).unwrap()
    } catch (error) {
    }
  }

  useEffect(() => {
    const userId = getUserId()
    if (dataLoaded === 'loading') return
    getUser(userId)
  }, [])

  useEffect(() => {
    if (!userData) return
    const groups = userData.groups
    if (!groups || groups.length === 0) return
    const sortedGroupsWithColor = getSortedGroupsWithColor(groups)
    setGroups(sortedGroupsWithColor)
  }, [userData])

  return (
    dataLoaded === 'loading' ? ( 
      <LoadingSpinner />
    ) : (
      <div style={isMobileView ? userProfileDivStyleMobile : userProfileDivStyle}>
        {dataLoaded === 'succeeded' && (
          <Grid container spacing={2}>
            <Container
              sx={{
                marginTop: '40px',
                height: '38px',
                position: 'relative',
                left: '0',
                marginLeft:'-4px',
              }}
            >
              <Link
                to="/"
                style={{
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                }}
                color="black"
              >
                <ArrowBackIcon
                  sx={{
                    marginRight: '2px',
                    padding: '5px 0 0 0',
                    color: 'black',
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'JohnsonText,Arial,sans-serif',
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '23.2px',
                    padding: '5px 0 0 0',
                    color: 'black',
                  }}
                >
                  {t('user-profile-back')}
                </Typography>
              </Link>
            </Container>
            <Container sx={titleContainerStyle}>
              <h1 data-testid="user-profile-id">{t('user-profile-my-profile')}</h1>
              {accessRole ? (
              <div>
                <Box sx={superAdminCapsule}>Super-admin</Box>
              </div>
            ) : (
              <>
              </>
            )}
            </Container>

            <Container sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                borderBottom: '1px solid #c1bbb3',
                marginTop: '15px',
                height: '60px',
                paddingBottom: '20px',
                gap: '24px',
                marginLeft:'24px',
                paddingLeft:'0px !important'
            }}>
            <Box
              sx={isMobileView ? infoContainerStyleMobile : {
                display: 'flex',
                alignItems: 'center',
                padding: '20px 0',
                width: '100%',
                marginTop: '15px',
                height: '50px',
                gap: '15px',
              }}
            >
              <Box sx={{ width: '42%' }}>
              <Typography variant="subtitle2" sx={infoTitleStyle}>
                {t('user-profile-name')}
              </Typography>
              </Box>
              <Box sx={{ width: '33%', display:'flex', justifyContent: 'left' }}>
              <Typography
                variant="subtitle1"
                sx={isMobileView ? infoTextStyleMobile : infoTextStyle}
              >
                {userData.name.givenName + ' ' + userData.name.familyName}
              </Typography>
              </Box>
              <Box sx={{ width: '25%', textAlign: 'right'}}>
              <Button
                variant="contained"
                type="button"
                onClick={() => navigate('/edit-name')}
                sx={editButtonStyle}
                disableElevation
                endIcon={<ArrowForwardIcon />}
              >
                {t('user-profile-user-name-edit')}
              </Button>
              </Box>
            </Box>
            </Container>
            <Container sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                borderBottom: '1px solid #c1bbb3',
                marginTop: '15px',
                height: '60px',
                paddingBottom: '20px',
                gap: '24px',
                marginLeft:'24px',
                paddingLeft:'0px !important'
            }}>
            <Box
              sx={isMobileView ? infoContainerStyleMobile : {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                padding: '20px 0',
                marginTop: '15px',
                height: '50px',
                gap: '15px',
              }}
            >
              <Box sx={{ width: '42%'}}>
              <Typography variant="subtitle2" sx={infoTitleStyle}>
                {t('user-profile-primary-email')}
              </Typography>
              </Box>
              <Box sx={{ width: '33%', display:'flex', justifyContent: 'left' }}>
              <Typography
                variant="subtitle1"
                className='secnMail'
                sx={isMobileView ? infoTextStyleEmailMobile : infoTextEmailStyle}
              >
                {userData.emails[0].value}
              </Typography>
              </Box>
              <Box sx={{ width: '25%', visibility: 'hidden'}}>
              </Box>
                         
            </Box>
            </Container>
            <Container sx={{ margin: '20px 0', width: '100%' }}>
              <Typography variant="subtitle2" sx={infoTitleStyle}>
                {t('user-profile-group-belong-to')}
              </Typography>
              <UserGroupsField groups={groups} label="Groups" />
            </Container>
          </Grid>
        )}
        {dataLoaded === 'failed' && <p>{`Error Occurred: ${dataErrorMessage}`}</p>}
      </div>
    )
  )
}
export default UserProfile
